"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePercentage = exports.calculateNetPriceFromGrossPriceAndTaxRate = exports.mapExportFormatToExportInfoProperty = exports.isExpenseVendorDefined = exports.isMileageOrPerDiem = exports.isAtLeastReviewed = void 0;
const models_1 = require("../models");
const common_1 = require("./common");
const isAtLeastReviewed = (status) => status === models_1.ExpenseStatusEnum.REVIEWED || status === models_1.ExpenseStatusEnum.PAID || status === models_1.ExpenseStatusEnum.DONE;
exports.isAtLeastReviewed = isAtLeastReviewed;
const isMileageOrPerDiem = (expense) => [models_1.ExpenseKindEnum.MILEAGE, models_1.ExpenseKindEnum.PER_DIEM].includes(expense.kind);
exports.isMileageOrPerDiem = isMileageOrPerDiem;
const isExpenseVendorDefined = ({ vendorType, creditorUser, vendor }) => {
    if (!vendorType)
        return false;
    if (vendorType === models_1.VendorTypeEnum.USER && (creditorUser === null || creditorUser === void 0 ? void 0 : creditorUser._id))
        return true;
    if (vendorType === models_1.VendorTypeEnum.VENDOR && (vendor === null || vendor === void 0 ? void 0 : vendor._id))
        return true;
    return false;
};
exports.isExpenseVendorDefined = isExpenseVendorDefined;
const mapExportFormatToExportInfoProperty = (format) => {
    switch (format) {
        case models_1.ExportFormatEnum.ALL:
            return "isExportedAsAll";
        case models_1.ExportFormatEnum.INVOICES:
            return "isExportedAsInvoices";
        case models_1.ExportFormatEnum.CSV:
            return "isExportedAsCSV";
        case models_1.ExportFormatEnum.CSV_LEXWARE:
            return "isExportedAsLexwareCSV";
        case models_1.ExportFormatEnum.DATEV:
            return "isExportedAsDatevZip";
        case models_1.ExportFormatEnum.DATEV_INVOICE_CSV:
            return "isExportedAsDatevInvoiceCsv";
        case models_1.ExportFormatEnum.DATEV_ONLINE:
            return "isExportedToDatevOnline";
        case models_1.ExportFormatEnum.SEPA:
            return "isExportedAsSepa";
        case models_1.ExportFormatEnum.NON_SEPA:
            return "isExportedAsNonSepa";
        // No export information associated with these enums
        case models_1.ExportFormatEnum.MARK_AS_DONE:
        case models_1.ExportFormatEnum.AUDIT_TRAIL:
        case models_1.ExportFormatEnum.CHANGE_HISTORY:
        default:
            return undefined;
    }
};
exports.mapExportFormatToExportInfoProperty = mapExportFormatToExportInfoProperty;
const calculateNetPriceFromGrossPriceAndTaxRate = (grossPrice, taxRate) => 
/*
The tax rate percentage is always based on the net, not the gross.
This is why the net price can't be calculated by doing
gross.percentage(taxRate), but the calculation below is needed
*/
taxRate ? (0, common_1.toAmount)((0, common_1.toDinero)(grossPrice).divide(1 + taxRate / 100)) : grossPrice;
exports.calculateNetPriceFromGrossPriceAndTaxRate = calculateNetPriceFromGrossPriceAndTaxRate;
const calculatePercentage = ({ price, taxRate }) => price.percentage(taxRate, "HALF_UP");
exports.calculatePercentage = calculatePercentage;
